<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBilling_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2H2zM2 12h20v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
    />
</svg>
